import Editor from '@toast-ui/editor';
import '@toast-ui/editor/dist/toastui-editor.css';

export const emailComposerMixin = {

    //********************* INIT EDITOR ********************************//
    // Creates a Toast UI WYSIWYG editor in the compose body, mirroring
    // directMessageChat's composerMixin.initEditor() - same toolbar, no
    // mention/emoji/Enter-to-send since this is a longer-form field with an
    // explicit Send button. Uses HTML (not markdown) since the result is
    // sent as real email HTML (see sendEmail in emailDataFetchMixin.js).
    // Called after every render() (see emailInbox.js's render()); no-ops
    // when the compose form isn't the current view.
    initEditor() {
        this.tuiEditor = null;
        const container = this.querySelector('.email_compose__editor_container');
        if(!container) return;

        this.tuiEditor = new Editor({
            el: container,
            initialEditType: 'wysiwyg',
            height: 'auto',
            minHeight: '140px',
            hideModeSwitch: true,
            toolbarItems: [
                ['bold', 'link', 'ol', 'code', 'codeblock'],
                ['italic', 'strike', 'quote', 'ul'],
            ],
            usageStatistics: false,
            hooks: {
                // Pasted/dropped images become attachments rather than inline
                // content, matching the chat compose box's behavior.
                addImageBlobHook: (blob) => {
                    const img = new Image();
                    img.onload = () => {
                        const canvas = document.createElement('canvas');
                        canvas.width = img.naturalWidth;
                        canvas.height = img.naturalHeight;
                        canvas.getContext('2d').drawImage(img, 0, 0);
                        canvas.toBlob((jpegBlob) => {
                            const now = new Date();
                            const month = now.toLocaleString('en-US', { month: 'short' }).toLowerCase();
                            const day = now.getDate();
                            const year = now.getFullYear();
                            const hours = now.getHours();
                            const minutes = String(now.getMinutes()).padStart(2, '0');
                            const file = new File([jpegBlob], `screenshot-${month}${day}-${year}-${hours}-${minutes}.jpg`, { type: 'image/jpeg' });
                            this.addComposeAttachment(file);
                        }, 'image/jpeg', 0.8);
                        URL.revokeObjectURL(img.src);
                    };
                    img.src = URL.createObjectURL(blob);
                }
            }
        });

        // Restores a draft carried over from a previous render (e.g. after a
        // validation/send error) - see sendCompose()'s composeState writeback.
        if(this.composeState.bodyHtml) this.tuiEditor.setHTML(this.composeState.bodyHtml);
    },

};
